import styled from 'styled-components';
import { FONT_SIZE_5, FONT_WEIGHT_NORMAL, GRAY_MEDIUM } from '../../styles/variables';
import { fontStyle, flexPosition } from '../../styles/mixins';

export const List = styled.div`
  padding: 0;
  overflow: auto;
  max-height: 500px;
  min-height: 170px;
  overflow-x: hidden;
  ${flexPosition({ justify: 'center' })}
`;

export const Header = styled.div`
  margin-bottom: ${props => (props.noVariations ? '120px' : '50px')};
`;

export const NoResult = styled.div`
  list-style: none;
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_NORMAL)}
  width: 190px;
  text-align: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/components/GenericVariationsList/style.js